import tw, { styled } from 'twin.macro';

const fontFamily = 'Circular Std';

export const DDWrapper = styled.div`
  ${tw`relative w-full bg-transparent mt-2`};
  outline-color: #85b7d9;

  &:focus {
    border-color: #85b7d9;
  }

  &.disabled {
    pointer-events: none;
  }

  ${({ inTable }) => inTable && `margin: 0`}
`;

export const DDHeader = styled.div`
  ${tw`w-full p-1.5 flex items-center opacity-70 bg-white`};
  border: 1px solid #dadada;
  min-height: 47px;
  border-radius: 3px;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    border-color: var(--formFieldBorderColor, #dadada);
    background: var(--formFieldBackgroundColor) !important;
    font-size: var(--formFontSize);
    border-radius: var(--formFieldBorderRadius);
    color: var(--formFieldColor, var(--formTextColor));
  `}

  &:focus {
    border-color: #85b7d9;
  }

  &.toggleDD {
    border-bottom: none !important;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-color: #85b7d990;

    :hover {
      border-color: #85b7d9 !important;
    }
  }
`;

export const DDOptionsWrapper = styled.div`
  ${tw`w-full flex items-center justify-between`};

  > div {
    ${tw`w-full`};
  }

  & .caret-down {
    ${tw`absolute right-0 top-4`};
    color: #888;
    font-size: 12px;
    z-index: 5;
  }
`;

export const SelectedOptions = styled.div`
  ${tw`flex-1 flex gap-1 items-center flex-wrap`};

  > span.selected {
    ${tw`select-none`};
    padding: 1px 10px;
    border-radius: 2px;
    font-family: var(--formFontType) !important;

    &.is-multiple {
      border: 1px solid #aaa;
      background-color: #eee;

      :hover {
        background-color: #ddd;
      }
    }

    > button.unselect {
      ${tw`m-0 p-0 ml-2.5 bg-transparent outline-none border-none cursor-pointer`};
      color: #aaa;
  
      &:hover {
        color: #555;
      }
    }
  }
`;

export const NoOptPlaceholder = styled.p`
  ${tw`select-none overflow-hidden whitespace-nowrap w-auto opacity-40`};
  padding: 5px 15px;
  text-overflow: ellipsis;
  font-family: var(--formFontType, ${fontFamily}) !important;
`;

export const DDBody = styled.div`
  ${tw`w-full absolute bg-white`};
  border: 1px solid #85b7d970;
  border-top: none;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  z-index: 200;
`;

export const OptionsList = styled.ol`
  ${tw`flex flex-col w-full overflow-y-scroll`};
  margin: 10px 0;
  max-height: 150px;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  li {
    ${tw`select-none p-1.5`};
    word-break: break-word;
    border-radius: 2px;
    outline-color: #eee;
    margin: 2px 0;
    font-family: var(--formFontType) !important;

    &.inSelected {
      background-color: whitesmoke;
    }

    &:hover {
      background-color: #eee !important;
    }
  }
`;

export const OptionsActions = styled.div`
  ${tw`flex flex-wrap mb-2.5 p-2.5 gap-1.5`};
`;

export const OptionsFilter = styled.div`
  ${tw`flex-1`};
`;

export const OptionButtons = styled.div`
  ${tw`flex flex-wrap gap-1.5`};

  > button {
    ${tw`py-1.5 px-6 font-medium text-sm rounded outline-none cursor-pointer bg-white`}
    height: 35px;
    flex: 1 1 auto;
    min-width: 100px;
    border: 1px solid;
    white-space: nowrap;
    transition: 200ms ease-in-out;
    font-family: var(--formFontType) !important;

    &.clear {
      color: #ed4c5c;

      :hover {
        background-color: #ed4c5c;
        color: white;
      }
    }

    &.all {
      color: #777;

      :hover {
        color: white;
        background-color: #777;
      }
    }

    &.done {
      color: #1a8caf;

      :hover {
        color: white;
        background-color: #00afc4;
      }
    }
  }
`;

export const OtherTextError = styled.span`
  color: #ed4c5c;
  font-family: var(--formFontType) !important;
  font-size: 13px;
  font-weight: 500;
`;

export const OptionsOtherInputWrapper = styled.div`
  ${tw`w-full mt-2.5`};
`;

export const Input = styled.input`
  ${tw`w-full h-full px-4 py-2.5 outline-none select-none font-medium`};
  min-width: 150px;
  border-radius: 2px;
  border: 1px solid #999;
  font-family: var(--formFontType) !important;
`;
